import React, {useMemo} from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded'
import {useTranslation} from 'react-i18next'

const OpenPaymentMenuItem = ({itemId, rowData, handleClose}) => {
    const {t} = useTranslation()

    const paymentToken = useMemo(
        () => rowData?.token || rowData?.paymentToken || rowData?.publicToken,
        [rowData]
    )

    const isPending = (rowData?.status || '').toLowerCase() === 'pending'

    if (!paymentToken || !isPending) {
        return null
    }

    const handleClick = (event) => {
        event?.stopPropagation()
        handleClose?.(event)
        window.open(`/payment/${paymentToken}`, '_blank', 'noopener')
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={handleClick}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t('menuItem.open_payment')}</div>
                <LaunchRoundedIcon fontSize="small" />
            </Box>
        </MenuItem>
    )
}

export default OpenPaymentMenuItem
